import useIsMounted from "../../../../../../hooks/use-is-mounted";
import React, {useCallback} from "react";
import {deepEqual} from "../../../../../../../core/services/utils/utils";
import SaveOrRollback from "../../../../../../components/app-specific/save-or-rollback";
import {Box, Paper, Typography} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import SalesPersonAutocomplete from "../../../../../../components/text-fields/autocomplete/sales-person-autocomplete";
import TerritoryAutocomplete from "../../../../../../components/text-fields/autocomplete/territory-autocomplete";
import Api from "../../../../../../../core/services/api/api";


const OrderSettingsSection = ({
                                  required,
                                  values,
                                  initialValues,
                                  form,
                                  submitting,
                                  deleting,
                                  customerId,
                                  setTerritory,
                                  setAccountManager,
                              }) => {
    const isMounted = useIsMounted();

    /**
     * Calls the api for updating the territory of a customer.
     */
    const updateTerritory = useCallback(async (territory, setLoading) => {
        setLoading?.(true);
        const response = await Api.updateCustomerOwner({
            id: customerId,
            territoryCode: territory?.code,
        })
        if (!isMounted())
            return;
        setLoading?.(false);
        if (response?.resultFlag) {
            setTerritory(territory);
        }
    }, [customerId, isMounted, setTerritory]);

    /**
     * Calls the api for updating the manager of a customer.
     */
    const updateAccountManager = useCallback(async (accountManager, setLoading) => {
        setLoading?.(true);
        const response = await Api.updateCustomerOwner({
            id: customerId,
            accountManagerId: accountManager?.operatorId,
        })
        if (!isMounted())
            return;
        setLoading?.(false);
        if (response?.resultFlag) {
            setAccountManager(accountManager);
        }
    }, [customerId, isMounted, setAccountManager]);


    return (
        <>
            <Paper sx={{padding: 2, display: 'flex', flexDirection: 'column', position: 'relative', height: '100%', gap: 3}}>
                <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2}}>
                    <Typography variant={'subtitle1'} fontWeight={600}>
                        Order Settings
                    </Typography>
                </Box>
                <Grid2 container spacing={2}>
                    <Grid2 xs={12} lg={6}>
                        <TerritoryAutocomplete
                            name="orderSettingsTerritory"
                            label="Territory"
                            placeholder="Search for territory..."
                            fullWidth
                            form
                            required={required.orderSettingsTerritory}
                        />
                        <SaveOrRollback
                            column={false}
                            show={!deepEqual(values.orderSettingsTerritory, initialValues.orderSettingsTerritory) && !deleting}
                            onRollback={() => form.change('orderSettingsTerritory', initialValues.orderSettingsTerritory)}
                            onSave={(setLoading) => !submitting && updateTerritory(values.orderSettingsTerritory, setLoading)}
                        />
                    </Grid2>
                    <Grid2 xs={12} lg={6}>
                        <SalesPersonAutocomplete
                            name="orderSettingsAccountManager"
                            label="Account Manager"
                            placeholder="Search for account manager..."
                            fullWidth
                            form
                            required={required.orderSettingsAccountManager}
                        />
                        <SaveOrRollback
                            column={false}
                            show={!deepEqual(values.orderSettingsAccountManager, initialValues.orderSettingsAccountManager) && !deleting}
                            onRollback={() => form.change('orderSettingsAccountManager', initialValues.orderSettingsAccountManager)}
                            onSave={(setLoading) => !submitting && updateAccountManager(values.orderSettingsAccountManager, setLoading)}
                        />
                    </Grid2>
                </Grid2>
            </Paper>
        </>
    );
}

export default OrderSettingsSection;